var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"editor_contant mal10 mar10"},[_c('div',{ref:"toolbar",staticClass:"toolbar_"}),_c('div',{ref:"editor",staticClass:"editor_"})])}
var staticRenderFns = []

export { render, staticRenderFns }